import Rollbar from 'rollbar';
import { isDevelopment } from 'utils';

declare global {
  interface Window {
    FS: any;
  }
}

// get the fullstory url if available
const getFullStoryUrl = (fs: any) => {
  try {
    return fs.getCurrentSessionURL(true);
  } catch {
    return 'Fullstory session URL API not available';
  }
};

export default new Rollbar({
  accessToken: process.env.REACT_APP_POST_CLIENT_ITEM_TOKEN,
  captureUncaught: !isDevelopment(),
  captureUnhandledRejections: !isDevelopment(),
  payload: {
    environment: process.env.REACT_APP_ENVIRONMENT,
    ...(window.FS && {
      custom: {
        fullstoryUrl: getFullStoryUrl(window.FS),
      },
    }),
  },
});
